import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function WhatsApp(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 303.95 305.42">
      <g id="WhatsApp" data-name="WhatsApp">
        <g id="WhatsApp_Logo" data-name="WhatsApp Logo">
          <path fill="currentColor" d="M0,305.42,21.47,227a151.1,151.1,0,0,1-20.2-75.66C1.3,67.89,69.19,0,152.61,0A151.35,151.35,0,0,1,304,151.45c0,83.45-67.93,151.34-151.34,151.34h-.06a151.16,151.16,0,0,1-72.32-18.42ZM83.94,257l4.6,2.73a125.6,125.6,0,0,0,64,17.53h.05c69.33,0,125.76-56.43,125.79-125.79A125.79,125.79,0,1,0,46.05,218.28L49,223l-12.7,46.42Z"/>
          <path fill="currentColor" fillRule="evenodd" d="M228.86,187.44c-1-1.58-3.47-2.53-7.25-4.42s-22.37-11-25.84-12.3-6-1.89-8.51,1.89-9.77,12.3-12,14.83-4.41,2.84-8.19.95-16-5.89-30.41-18.77c-11.25-10-18.83-22.41-21-26.2s-.24-5.83,1.66-7.72c1.7-1.69,3.78-4.41,5.67-6.62a25.9,25.9,0,0,0,3.78-6.31,7,7,0,0,0-.31-6.63c-1-1.89-8.51-20.5-11.66-28.07-3.07-7.38-6.19-6.38-8.51-6.49s-4.73-.14-7.25-.14A13.9,13.9,0,0,0,89,86.17C85.48,90,75.71,99.11,75.71,117.72s13.55,36.6,15.44,39.12,26.67,40.72,64.6,57.1a215.38,215.38,0,0,0,21.56,8,51.73,51.73,0,0,0,23.82,1.5c7.26-1.08,22.37-9.15,25.52-18S229.8,189,228.86,187.44Z"/>
        </g>
      </g>
    </SvgIcon>
  );
}
